<script>
import metaInfo from '@/modules/mixins/metaInfo'
import Vue from 'vue'
import { Notifications } from '@/api/notification'
import option from '@/modules/store/modules/option/type'
import CheckboxPreference from '@/components/molecules/input/CheckboxPreference'
import { mapGetters } from 'vuex'

const notifications = Vue.observable(new Notifications(Vue.prototype.$isSupported))

export default {
    name: 'Notifications',
    components: { CheckboxPreference },
    mixins: [metaInfo],
    data() {
        return {
            user: this.$user.model,
            loading: false,
        }
    },
    computed: {
        ...mapGetters({
            availableNotifications: option.getActionName(
                option.optionTypes.USER_NOTIFICATION_SETTINGS,
                option.getters.OPTIONS
            ),
        }),
        pageTitle() {
            return this.$t('profile.pages.preferences')
        },
        notifications: () => notifications,
        supportedPush() {
            return this.notifications.supportedPush
        },
        categories() {
            let groupIndex, category
            return this.availableNotifications.reduce((p, c) => {
                category = c.id?.split('_')?.[0].toLowerCase()
                groupIndex = p.findIndex((group) => group.type === category)
                if (groupIndex === -1) p.push({ type: category, notifications: [c] })
                else p[groupIndex].notifications.push(c)
                return p
            }, [])
        },
    },
    mounted() {
        this.$store.dispatch(
            option.getActionName(option.optionTypes.USER_NOTIFICATION_SETTINGS, option.actions.LOAD)
        )
    },
    methods: {
        async save(key) {
            try {
                this.loading = key
                await this.$user.update(this.user)
            } finally {
                this.loading = false
            }
        },
        isPush(key) {
            return key.includes('_push')
        },
        async setNotificationsPermission(allow) {
            try {
                this.loading = 'general'
                if (allow) {
                    await this.notifications?.register()
                } else {
                    await this.notifications.unregister()
                    this.availableNotifications.forEach((type) => {
                        this.$set(this.user.notification_settings, type.key, false)
                    })
                    await this.save()
                }
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<template lang="pug">
.profile-notifications
    template(v-for="(category, index) in categories")
        h2(:key="`notificationLabel-${index}`") {{ $t(`profile.notification_groups.${category.type}`) }}
        .card.mb-8(:key="`notificationGroup-${index}`")
            .card-body
                checkbox-preference(
                    v-for="type in category.notifications"
                    v-model="user.notification_settings[type.key]"
                    :key="`notification-${type.id}`"
                    :label="$t(`profile.notification_groups.${type.name}_label`)"
                    :desc="$t(`profile.notification_groups.${type.name}_desc`)"
                    :supported="!isPush(type.key) || supportedPush"
                    icon="fa-bell"
                    :information="$t('profile.push_not_supported')"
                    :readonly="loading === type.key"
                    :loading="loading === type.key"
                    @input="save(type.key)")
</template>
